import './App.css';
import Header from './components/Header';
import Body from './components/Body';
import Saying from './components/Saying';
import Toped from './components/Toped';
import List from './components/List';

function App() {
  const toppers=[
    {
      name:"Saimon Lama",
      marks:"98%",
      location:"Baudha, Kathmandu"
    },
    
    {
      name:"Saimon Lama",
      marks:"98%",
      location:"Baudha, Kathmandu"
    },
    {
      name:"Saimon Lama",
      marks:"98%",
      location:"Baudha, Kathmandu"
    },
    {
      name:"Saimon Lama",
      marks:"98%",
      location:"Baudha, Kathmandu"
    },
    {
      name:"Saimon Lama",
      marks:"98%",
      location:"Baudha, Kathmandu"
    },
    {
      name:"Saimon Lama",
      marks:"98%",
      location:"Baudha, Kathmandu"
    },
    {
      name:"Saimon Lama",
      marks:"98%",
      location:"Baudha, Kathmandu"
    },
    {
      name:"Saimon Lama",
      marks:"98%",
      location:"Baudha, Kathmandu"
    },
    {
      name:"Saimon Lama",
      marks:"98%",
      location:"Baudha, Kathmandu"
    },

  ]
  return (
    <div className="App">
    <Header />
    <Body />
    <Saying />
    <Toped />
    <List name={toppers[0].name}  location={toppers[0].location}  marks={toppers[0].marks}/>
    </div>
  );
}

export default App;
